import { useIntl } from "react-intl";

type Props = {
	isLoading: boolean;
	handleSearch: (text: string) => void;
	handleHomeDataReload: () => void;
};

/**
 * Render header for authenticated users.
 * Input search filter local data.
 * Button refresh data from server.
 * @returns
 */
export default function HeaderSearch({ isLoading, handleSearch, handleHomeDataReload }: Props) {
	const intl = useIntl();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		handleSearch(e.target.value);
	};
	const handleSearchClick = () => {
		handleHomeDataReload();
	};

	return (
		<div className="input-group position-relative">
			<input
				type="text"
				className="form-control"
				placeholder={intl.formatMessage({ id: "search" })}
				onChange={handleChange}
			/>
			<span className="input-group-text position-relative p-0">
				<button
					type="button"
					className="input-group-text position-relative border-0 bg-light"
					onClick={handleSearchClick}
					style={{ cursor: "pointer" }}
				>
					{isLoading ? (
						<div className="spinner-border spinner-border-sm" role="status">
							<span className="sr-only">Loading...</span>
						</div>
					) : (
						<>
							<i className="fas fa-search"></i>
							<i
								className="fa-solid fa-arrows-rotate position-absolute"
								style={{
									top: "3px",
									left: "3px",
									fontSize: "0.6em",
								}}
							></i>
						</>
					)}
				</button>
			</span>
		</div>
	);
}
